export default [
  {
    title: '账号ID',
    key: 'userId',
    width: 60
  },
  {
    title: '角色名称',
    key: 'roleName',
    type: 'basic',
    width: 82
  },
  {
    title: '角色创建时间',
    key: 'createRoleTime',
    sortable: 'custom',
    type: 'basic',
    width: 100
  },
  {
    title: '游戏',
    key: 'gameName',
    type: 'basic',
    width: 104
  },
  {
    title: '等级',
    key: 'roleLevel',
    sortable: 'custom',
    type: 'basic',
    width: 60
  },
  {
    title: '付费次数',
    key: 'rolePayCount',
    sortable: 'custom',
    type: 'basic',
    width: 62
  },
  {
    title: '充值金额',
    key: 'money',
    sortable: 'custom',
    type: 'basic',
    width: 62
  },
  {
    title: '区服',
    key: 'serverName',
    type: 'basic',
    width: 86
  },
  {
    title: '设备类型',
    key: 'phone',
    type: 'basic',
    width: 120
  },
  {
    title: '最后登录时间',
    key: 'lastLoginTime',
    sortable: 'custom',
    type: 'basic',
    width: 100
  }
]
